import React from "react";
import "./Teams.css";
import team1 from "../../../images/team1.jpg";
import team2 from "../../../images/team2.jpg";
import team3 from "../../../images/team3.jpg";
const Teams = () => {
  return (
    <>
      <h2 className="text-center text-bold">TEAM</h2>
      <div class="container">
        <div class="card">
          <h2>David Manfield</h2>
          <div class="title title--epic">Programmer</div>
          <div class="desc">
            David can develop any kind of software, he started learning to code
            for about 10 years!
          </div>
          <img className="teamImg" src={team3} alt="" width="100%" />
        </div>
        <div class="card">
          <h2>Morgan Sweeney</h2>
          <div class="title title--legendary">Ant Collector</div>
          <div class="desc">
            Morgan has collected ants since they were six years old and now has
            many dozen ants but none in their pants.
          </div>
          <img className="teamImg" src={team1} alt="" width="100%" />
        </div>
        <div class="card">
          <h2>Isaac Armstrong</h2>
          <div class="title title--common">Walmart Cashier</div>
          <div class="desc">
            Isaac know very well every dollar and can identify fake ones from 10
            miles away.
          </div>
          <img className="teamImg" src={team2} alt="" width="70%" />
        </div>
      </div>
    </>
  );
};

export default Teams;
